import jwt_decode from "jwt-decode";
import * as firebase from "firebase/app";
import "firebase/auth";

const tokenName = "session";

export const refreshToken = () => {
  firebase
    .auth()
    .currentUser.getIdToken(true)
    .then(function (idToken) {
      saveToken(idToken);
    })
    .catch(function (error) { });
};

export const getProperties = () => {
  const token = localStorage.getItem(tokenName) || "";
  if (token === "") {
    return {};
  }
  const decoded = jwt_decode(token);

  const {
    email,
    email_verified,
    user_id: id,
    exp: expiry
  } = decoded;
  return { email, email_verified, id, expiry };
};

export const saveToken = token => {
  localStorage.setItem(tokenName, token);
  // const decoded = jwt_decode(token);
};

export const getTokenWithoutUpdate = () => localStorage.getItem(tokenName) || "";

export const logoutSession = () => localStorage.removeItem(tokenName);
